export const ALERT_MESSAGES = {
  EMAIL_NOT_SENT: 'No pudimos enviar el email',
  EMAIL_NOT_SENT_MESSAGE: 'Tuvimos un inconveniente cuando intentamos enviar el email, por favor intenta de nuevo',
  EMAIL_SENT: 'Email enviado',
  EMAIL_SENT_MESSAGE: 'Hemos enviado a tu email las instrucciones para la aprobación de tu compra',
  EMAIL_NOT_SENT_RATE_LIMIT: 'Por motivos de seguridad, el envío de correos ha sido bloqueado. Por favor, inténtalo de nuevo más tarde.'
};

export const ALERT_BUTTONS_MESSAGES = {
  THANKS: '¡Gracias!'
}

export const PARAMS_TO_ORDER_LIST = {
  PRIORITY: 'priority'
}